import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFF",
  d: "M23.387 12.07C23.387 5.583 18.29.325 12 .325S.613 5.583.613 12.07c0 5.862 4.164 10.72 9.608 11.602v-8.207H7.33V12.07h2.891V9.482c0-2.943 1.7-4.569 4.301-4.569 1.246 0 2.549.23 2.549.23v2.89h-1.436c-1.415 0-1.856.905-1.856 1.834v2.203h3.158l-.504 3.395h-2.654v8.207c5.444-.881 9.608-5.74 9.608-11.602"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }